<template>
  <div>
      {{ label ? $t(label).concat(': ') : ''}}
    <v-layout wrap align-center
      :style="{ 'width' : `${width}px`}"
    >
      <v-flex xs6
        style="border-style: solid;border-width: 1px;border-color:#CCC;border-radius: 4px;cursor: pointer;"
        :style="{ 'background-color' : selectedColor}"
        @click="showColorDialog = !showColorDialog"
      >
        <center style="padding: 10px 0;">
          <v-icon :color="getOppositeColor(selectedColor)">mdi-format-color-fill</v-icon>
        </center>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showColorDialog" persistent max-width="330px" >
      <v-card style="padding: 10px;">
      <v-color-picker
        v-model="selectedColor"
        class="ma-2"
        :swatches="swatches"
        show-swatches
        mode="hexa"
      />
      <center>
        <v-btn
          @click="handleClearColor"
          style="margin-bottom:10px;"
        >
          <v-icon>mdi-water-off</v-icon> {{$t('common.clear')}}
        </v-btn>
        <v-btn
          @click="handleChangeColor"
          :color="enterpriseColor"
          dark
          style="margin-left:10px;margin-bottom:10px;"
        >
          <v-icon>mdi-close</v-icon> {{$t('common.close')}}
        </v-btn>
      </center>
    </v-card>
    </v-dialog>    
  </div>
</template>

<script>
  import tinycolor from 'tinycolor2'
  export default {
    name: 'CustomColorPickerBGAndText',
    props: {
      label: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      width: {
        type: String,
        required: false,
        default: null
      },
      height: {
        type: String,
        required: false,
        default: '36px'
      },
      Color: {
        type: String,
        required: false,
        default: null
      },
      onChangeColor: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      showColorDialog: false,
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#FFFFFF', '#0000AA', '#000055'],
      ],
      selectedColor: null,
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    watch: {
      Color (v) {
        this.selectedColor = v
      },
    },
    mounted () {
      this.selectedColor = this.Color ? this.Color : '#fff'
    },
    methods: {
      getOppositeColor(color){
        if (!color) return '#000'
        return tinycolor(color).isLight() ? '#000' : '#FFF'
      },
      handleChangeColor () {
        this.showColorDialog = false
        this.onChangeColor(this.selectedColor)
      },
      handleClearColor () {
        this.selectedColor = null
        this.handleChangeColor ()
      },
    }
  }
</script>